/* ══════════════════════════════════════════════════════════════════
   GK Motion JS — Orbit §3 (v2). Vanilla, tanpa library, load defer.
   Isi: scroll reveal (stagger), count-up angka, kartu lift+tilt,
   parallax drift layer hero. Semua hormat prefers-reduced-motion.
   Kontrak dengan gk-motion.css:
   - html.gk-js dipasang inline oleh section; file ini MENCABUTNYA
     kalau IntersectionObserver tidak ada (konten langsung tampil).
   - Reveal: grup [data-gk-reveal-group] berisi [data-gk-reveal].
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;

  if (!hasIO || reduce) {
    /* Tanpa IO atau user minta reduce motion: jangan sembunyikan apa pun. */
    root.classList.remove('gk-js');
  }

  /* ── Scroll reveal ────────────────────────────────────────────── */
  if (hasIO && !reduce) {
    var groups = [].slice.call(doc.querySelectorAll('[data-gk-reveal-group]'));
    groups.forEach(function (g) {
      [].slice.call(g.querySelectorAll('[data-gk-reveal]')).forEach(function (el, i) {
        if (!el.style.getPropertyValue('--gk-ri')) el.style.setProperty('--gk-ri', i);
      });
    });
    var singles = [].slice.call(doc.querySelectorAll('[data-gk-reveal]')).filter(function (el) {
      return !el.closest('[data-gk-reveal-group]');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('gk-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    groups.forEach(function (g) { io.observe(g); });
    singles.forEach(function (el) { io.observe(el); });
  }

  /* ── Count-up angka (Orbit 3.4 v2) ────────────────────────────
     [data-gk-countup] berisi teks seperti "12.000+" (pemisah ribuan
     id-ID). Fail-safe: tanpa IO / reduced motion, teks statis utuh. */
  (function () {
    var els = [].slice.call(doc.querySelectorAll('[data-gk-countup]'));
    if (!els.length || !hasIO || reduce || !('requestAnimationFrame' in window)) return;

    var items = [];
    els.forEach(function (el, i) {
      var raw = el.textContent;
      var m = raw.match(/\d[\d.]*/);
      if (!m) return;
      var target = parseInt(m[0].replace(/\./g, ''), 10);
      if (isNaN(target)) return;
      items.push({
        el: el, raw: raw, target: target,
        prefix: raw.slice(0, m.index),
        suffix: raw.slice(m.index + m[0].length),
        delay: i * 120,
        done: false
      });
    });
    if (!items.length) return;

    function animate(it) {
      var dur = 1200, start = null;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3); /* easeOutCubic, satu DNA */
        if (p < 1) {
          it.el.textContent = it.prefix + Math.round(it.target * e).toLocaleString('id-ID') + it.suffix;
          requestAnimationFrame(frame);
        } else {
          it.el.textContent = it.raw;
        }
      }
      requestAnimationFrame(frame);
    }

    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        items.forEach(function (it) {
          if (it.done || !en.target.contains(it.el)) return;
          it.done = true;
          window.setTimeout(function () { animate(it); }, it.delay);
        });
        cio.unobserve(en.target);
      });
    }, { threshold: 0.35 });

    /* Amati wadah terdekat supaya semua angka satu band mulai serempak
       (lalu stagger via delay), bukan satu-satu saat nongol. */
    var seen = [];
    items.forEach(function (it) {
      var host = it.el.closest('[data-gk-reveal-group]') || it.el;
      if (seen.indexOf(host) === -1) { seen.push(host); cio.observe(host); }
    });
  })();

  /* ── Kartu lift + tilt (Orbit 3.3) ────────────────────────────
     Target: kartu DS yang ada di halaman. Maks tilt ±2.5deg, lift 4px.
     Hanya pointer halus + hover sungguhan + bukan reduced motion. */
  (function () {
    if (!fine || reduce) return;
    var SEL = '[data-gk-tilt], .gk-product-card, a.gk-icon-card, .gk-plist-card';
    [].slice.call(doc.querySelectorAll(SEL)).forEach(function (card) {
      card.classList.add('gk-tilt');
      var raf = null, rect = null;
      card.addEventListener('pointerenter', function () {
        rect = card.getBoundingClientRect();
        card.style.setProperty('--gk-lift', '-4px');
        card.classList.add('gk-tilting');
      });
      card.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!rect) rect = card.getBoundingClientRect();
          var px = (e.clientX - rect.left) / rect.width - 0.5;
          var py = (e.clientY - rect.top) / rect.height - 0.5;
          card.style.setProperty('--gk-ry', (px * 5).toFixed(2) + 'deg');
          card.style.setProperty('--gk-rx', (py * -5).toFixed(2) + 'deg');
        });
      });
      card.addEventListener('pointerleave', function () {
        rect = null;
        card.classList.remove('gk-tilting');
        card.style.setProperty('--gk-rx', '0deg');
        card.style.setProperty('--gk-ry', '0deg');
        card.style.setProperty('--gk-lift', '0px');
      });
    });
  })();

  /* ── Titik "di sini." kedip 3x lalu tetap (audit 2026-07-23, item 3) ──
     Judul hero adalah setting richtext, jadi titik terakhirnya dibungkus di
     sini (bukan di-hardcode di setting). Hanya di landing ([data-gk-dot]).
     Animasinya sendiri di gk-motion.css; tanpa JS/reduced-motion titik tampil
     statis dan utuh. */
  (function () {
    var t = doc.querySelector('.gk-hero__title[data-gk-dot]');
    if (!t) return;
    if (t.querySelector('.gk-dot')) return;
    /* Bungkus titik paling akhir, walau diikuti tag penutup (mis. </p>). */
    t.innerHTML = t.innerHTML.replace(
      /\.(\s*(?:<\/[a-z0-9]+>\s*)*)$/i,
      '<span class="gk-dot">.</span>$1'
    );
  })();

  /* ── Parallax drift (Orbit 3.1 v2) ────────────────────────────
     Layer [data-gk-drift] (rute penerbangan hero) bergeser maksimal
     10px berlawanan arah kursor, di-lerp biar kalem. */
  (function () {
    if (!fine || reduce || !('requestAnimationFrame' in window)) return;
    [].slice.call(doc.querySelectorAll('[data-gk-drift]')).forEach(function (layer) {
      var host = layer.parentElement;
      if (!host) return;
      var tx = 0, ty = 0, cx = 0, cy = 0, running = false;
      function loop() {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        layer.style.transform = 'translate3d(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px,0)';
        if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) {
          requestAnimationFrame(loop);
        } else {
          running = false;
        }
      }
      function kick() {
        if (!running) { running = true; requestAnimationFrame(loop); }
      }
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * -10;
        ty = ((e.clientY - r.top) / r.height - 0.5) * -6;
        kick();
      });
      host.addEventListener('pointerleave', function () {
        tx = 0; ty = 0; kick();
      });
    });
  })();
})();
